import angular from 'angular';
import display from './builder/display.html';
import data from './builder/data.html';
import validate from './builder/validate.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/number/display.html', display);
	$templateCache.put('kform/components/number/data.html', data);
	$templateCache.put('kform/components/number/validate.html', validate);
});
